module.exports = __webpack_public_path__ + "static/media/feeling_blue.d14cd80e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/feeling_blue.svg
// module id = 1095
// module chunks = 2